<template lang="pug">
  .div
    template(v-if="isLoading === true")
      Loading
    template(v-else)
      b-form-text.mb-3 ご契約環境を選択してください。
    b-container
      template(v-for="contract in contracts")
        b-card.card-layout.mb-3(header="ご契約環境")
          b-card-text
            h6.font-weight-bold ドメイン名
            p.mb-1.ml-2(v-for="domain in contract.domain_name") {{ domain }}
          b-card-footer.text-center.py-2
            b-button.mb-1.mr-1(size="sm" :class="getColor(contract.domain_name)", @click="movePreviousPage(contract.contract_no)") {{ buttonName }}

</template>

<script>
import Loading from '@/components/Loading'

import Api from '@/repositories/api'
const C206ContractInfo = Api.get('c206ContractInfo');

export default {
  name: "ContractSelect",
  components: {
    Loading
  },
  data() {
    return {
      // 契約情報
      contracts: [],
      // 契約種別
      contract_class: null,
      // 前画面
      previous: '',

      // ローディングフラグ
      isLoading: false,
    }
  },
  computed: {
    /**
     * ボタン名を表示
     */
    buttonName() {
      // 契約内容確認画面から遷移してきた場合
      if (this.previous === 'NeoServiceDetail' || this.previous === 'ChatServiceDetail' || this.previous === 'ContractDetails') {
        return '契約内容確認'
      }
      // ご契約内容変更お申し込み画面 または ユーザー数変更画面から遷移してきた場合
      if (this.previous === 'NeoServiceChange' || this.previous === 'ChatServiceChange' || this.previous === 'NeoNumberChange' || this.previous === 'ContractChanges') {
        return '変更申込み'
      }
      // ご契約お申し込み画面から遷移してきた場合
      if (this.previous === 'ContractNeoOrder' || this.previous === 'ContractChatOrder') {
        return '申し込む'
      }
      // 申し込み履歴画面から遷移してきた場合
      if (this.previous === 'OrderHistory') {
        return '申し込み履歴'
      }
      // 見積書一覧画面から遷移してきた場合
      if (this.previous === 'QuotationList') {
        return '見積書一覧'
      }
      // 上記以外の場合
      return '選択する'
    }
  },
  created () {
    // ローディングを開始する
    this.isLoading = true

    // 前画面を取得
    this.previous = sessionStorage.getItem('previous')

    // パラメータを設定
    let params = {}
    // セッションストレージに契約種別が存在する場合、パラメータに追加
    this.contract_class = sessionStorage.getItem('contract_class')
    if (this.contract_class !== null) {
      params.contract_class = this.contract_class
    }

    // C20601_契約情報取得処理を実行する
    C206ContractInfo.get(params)
      .then((response) => {
        // レスポンスを設定
        this.contracts = response.data.data
      })
      // エラーの場合
      .catch((error) => {
        // 共通のエラー処理
          this.apiError(error, '画面表示処理', "Support")

          // 画面TOPまでスクロールをする
          this.pageTopScroll()
      })
      // 処理終了後
      .finally(() => {
        // ローディング終了
        this.isLoading = false
      })
  },
  methods: {
    /**
     * 契約情報から背景色やボタン色の決定
     */
    getColor(domain_name) {
      // desknet's NEOの環境を持っているかのフラグ
      let bHasNeo = false
      // ChatLuckの環境を持っているかどうかのフラグ
      let bHasChat = false

      // 各ドメイン名を見ていく
      domain_name.forEach((item) => {
        // ドメイン名がdesknet's NEOの場合
        if (item.indexOf('dn-cloud.com') > -1) {
          // desknet's NEOの契約を持っている
          bHasNeo = true
        }
        // ドメイン名がChatLuckの場合
        if (item.indexOf('chatluck.net') > -1) {
          // ChatLuckの契約を持っている
          bHasChat = true
        }
      })

      // 対応した色を返す
      // desknet's NEOとChatLuck両方を持っている場合
      if (bHasNeo === true && bHasChat === true) {
        return 'btn-plan'
      }
      else if (bHasNeo === true) {
        return 'btn-neo'
      }
      else if (bHasChat === true) {
        return 'btn-chat'
      }
      // 上記以外は空文字を返す
      return ''
    },
    /**
     * 前画面へ遷移
     *
     * @param {string} contract_no 契約番号
     */
    movePreviousPage(contract_no) {
      // 前画面が設定されている場合
      if (this.previous !== null) {
        // 正しい遷移の場合
        if (
          this.previous === 'NeoServiceDetail' ||
          this.previous === 'ChatServiceDetail' ||
          this.previous === 'ContractDetails' ||
          this.previous === 'NeoServiceChange' ||
          this.previous === 'ChatServiceChange' ||
          this.previous === 'ContractChanges' ||
          this.previous === 'NeoNumberChange' ||
          this.previous === 'ContractNeoOrder' ||
          this.previous === 'ContractChatOrder' ||
          this.previous === 'OrderHistory' ||
          this.previous === 'QuotationList' ||
          this.previous === 'ApplyPlan'
        ) {
          // 該当の画面に戻る
          this.$router.push({ name: this.previous, params: { contract_no: contract_no } })
        }
        // 上記以外の場合
        else {
          this.$router.push({ name: 'TopPage' })
        }
      }
      // 前画面が設定されていない場合
      else {
        this.$router.push({ name: 'TopPage' })
      }
    },
  }
}
</script>

<style scoped lang="scss">
// カードのレイアウト
.card-layout {
  min-width: 400px;
  max-width: 400px;
}

// NEO・Chat契約のボタンの色
.btn-plan {
  color: #fff;
  background-color: #eb6ea0;
  border-color: #eb6ea0;

  &:hover {
    color: #fff;
    background-color: #e65d94;
    border-color: #e65d94;
  }

  &:focus, &.focus {
    box-shadow: 0 0 0 0.2rem rgba(235, 110, 160, 0.5);
  }

  &:disabled, &.disabled {
    background-color: #eb6ea0;
    border-color: #eb6ea0;
  }
}

// desknet's NEO契約のボタン色
.btn-neo {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;

  &:hover {
    color: #fff;
    background-color: #0069d9;
    border-color: #0062cc;
  }

  &:focus, &.focus {
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.5);
  }

  &:disabled, &.disabled {
    background-color: #007bff;
    border-color: #007bff;
  }
}

// ChatLuck契約のボタン色
.btn-chat {
  color: #fff;
  background-color: #28a745;
  border-color: #28a745;

  &:hover {
    color: #fff;
    background-color: #218838;
    border-color: #1e7e34;
  }

  &:focus, &.focus {
    box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.5);
  }

  &:disabled, &.disabled {
    background-color: #28a745;
    border-color: #28a745;
  }
}
</style>
